import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { WizardStepIndex } from "../../shared/enums/WizardStep";
import { scrollToHelper } from "../../shared/helpers/scrollToHelper";
import { MuiBreakPointsPx } from "../../shared/muiBreakPoints";
import { action } from "../../store/action";
import { useMarket } from "../../store/hooks/useMarket";
import Market from "../Market/MarketComponent";
import DisclamerText from "../shared/DisclamerText";
import WizardContainer from "./Container/WizardContainer";
import "./MarketStep.scss";

const WAIT_UNTIL_COMPONENT_IS_LOADED = 300;

const MarketStep = () => {
  const refMarketInfo = useRef(undefined);
  const dispatch = useDispatch();
  const market = useMarket();
  const { t } = useTranslation("marketstep");

  useEffect(() => {
    const hasMarket = market ? true : false;
    dispatch(
      action.saveWizard({
        activeStepIndex: WizardStepIndex.Market,
        enableNext: hasMarket,
      })
    );
  }, [dispatch, market]);

  useEffect(() => {
    if (window.innerWidth < MuiBreakPointsPx.sm) {
      setTimeout(() => {
        refMarketInfo.current.scrollIntoView(scrollToHelper.options);
      }, WAIT_UNTIL_COMPONENT_IS_LOADED);
    }
  }, []);

  useEffect(() => {
    dispatch(action.saveIsLoadedFromSummary(false));
  }, [dispatch]);

  return (
    <WizardContainer>
      <div>
        <div className="marketIntro desktopWidth">
          <h1>{t("markettexts.marketheader")}</h1>
          <div>
            <p>{t("markettexts.marketintro")}</p>
          </div>
        </div>
        <div className="marketBoxContainer" ref={refMarketInfo}>
          <div className="marketBox">
            <h2>{t("markettexts.chosemarketheader")}</h2>
            <div className="marketInfo">{t("markettexts.marketnotfound")}</div>
            <Market />
          </div>
        </div>
        <div>
          <DisclamerText />
        </div>
      </div>
    </WizardContainer>
  );
};

export default MarketStep;
